/* Trappbutiken – delad karusell (Wubs), med LOOP.
 *
 * Initierar VARJE [data-wth-carousel] på sidan. Markupen ska bära:
 *   [data-wth-carousel]        rot   (data-wth-carousel-loop="av" stänger av loopen)
 *     [data-wth-carousel-track]  scroll-spåret (flex + scroll-snap i CSS)
 *       korten: .wubs-prods__item, .wpb-slide eller [data-carousel-item]
 *     [data-wth-carousel-nav]    pilar + prickar (hidden tills det finns mer än en sida)
 *       .wpb-arrow-btn[data-dir="prev"|"next"]
 *       [data-wth-carousel-dots]
 *
 * Används av wubs-home-populart, wubs-pdp-related, wubs-article, wubs-home-omdomen och
 * wubs-pdp-reviews. (Heroslidern och kampanjbannern är bildspel med egen kod.)
 * ⚠️ Spåret innehåller KLONER av korten. Sektionskod som rör korten måste hämta dem när den
 * körs – inte en gång vid start – och lyssna på klick på spåret i stället för per kort: en klon
 * får inga lyssnare när den kopieras. Se recensionssektionernas "Läs mer".
 *
 * ── SÅ FUNGERAR LOOPEN ────────────────────────────────────────────────────────────────
 * Spåret är en vanlig `overflow-x: auto`-container, inte en transform-slider. Loopen görs
 * därför med KLONER: minst en hel uppsättning läggs före och en efter de riktiga korten, och
 * när scrollpositionen passerat en hel uppsättning teleporteras den tillbaka. Eftersom
 * klonerna är identiska med originalen visar skärmen exakt samma pixlar före och efter
 * hoppet – det syns inte.
 *
 * ⚠️⚠️ TELEPORTEN SKER NÄR SCROLLEN STANNAT – fingret lyft, tröghet och snap klara – aldrig
 * mitt i den. Att skriva scrollLeft under en pågående dragning eller tröghetsrullning avbryter
 * rullningen och får spåret att hoppa. Se scroll-lyssnaren längst ned.
 */
(function () {
  var KLON = 'data-wubs-klon';
  /* `scrollend` säger exakt när ALL rullning är klar – också tröghet och snap, och först när
   * fingret lyfts. Saknas den (äldre Safari) – eller uteblir den – tar en debounce med
   * fingervakt över, se planeraSlut(). */
  var HAR_SCROLLEND = 'onscrollend' in window;

  /* Avstånd mäts med getBoundingClientRect, inte offsetLeft. offsetLeft AVRUNDAS till hela
   * pixlar, och korten är vw-breda (t.ex. 331,2 px) – ett varvbyte på en avrundad setbredd
   * landar då en bråkdels pixel från snap-punkten och snappen flyttar spåret efteråt.
   * Skillnaden mellan två kort påverkas inte av scrollpositionen. */
  function x(el) { return el.getBoundingClientRect().left; }

  function init(root) {
    if (root.dataset.wubsCarouselInit) return;
    var track = root.querySelector('[data-wth-carousel-track]');
    var nav = root.querySelector('[data-wth-carousel-nav]');
    var dotsWrap = root.querySelector('[data-wth-carousel-dots]');
    if (!track || !nav) return;
    root.dataset.wubsCarouselInit = '1';

    var loopa = root.getAttribute('data-wth-carousel-loop') !== 'av';
    var VAL = '.wubs-prods__item, .wpb-slide, [data-carousel-item]';

    function alla() { return [].slice.call(track.querySelectorAll(VAL)); }
    function riktiga() {
      return alla().filter(function (e) { return !e.hasAttribute(KLON); });
    }

    /* Kortets steglängd = avståndet mellan två korts vänsterkanter (bredd + gap). */
    function step() {
      var c = alla();
      if (c.length > 1) return Math.max(1, x(c[1]) - x(c[0]));
      if (c.length === 1) return Math.max(1, c[0].getBoundingClientRect().width);
      return Math.max(1, track.clientWidth);
    }
    /* Antal HELA kort från snap-linjen till spårets högerkant – så långt en pil flyttar och så
     * många kort en prick-sida rymmer.
     * ⚠️ Inte `round(clientWidth / step)`: clientWidth räknar in spårets padding, och vid 1440
     * gav det 5 per vy fast bara 4,4 syns. Pilen hoppade då förbi det halvsynliga femte kortet,
     * som kunden aldrig fick se helt. */
    function perView() {
      var c = alla()[0];
      if (!c) return 1;
      /* offsetWidth, inte getBoundingClientRect: scroll-revealen skalar recensionskorten (0,96)
       * innan de syns, och den skalade bredden hade gjort gapet ~13 px för stort. */
      var st = step(), gap = Math.max(0, st - c.offsetWidth);
      var spl = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      return Math.max(1, Math.floor((track.clientWidth - spl + gap + 0.5) / st));
    }

    /* ⚠️ Overflow mäts på de RIKTIGA korten. Med kloner i spåret svämmar det alltid över,
     * så `scrollWidth` hade sagt "det finns fler sidor" även när allt får plats. */
    function riktigMaxScroll() {
      var r = riktiga();
      if (!r.length) return 0;
      var sista = r[r.length - 1];
      /* Layoutmått (offset*), inte getBoundingClientRect: revealens skalning av korten hade dragit
       * in båda kanterna. Heltalsavrundningen spelar ingen roll mot tröskeln på 4 px. */
      return sista.offsetLeft + sista.offsetWidth - r[0].offsetLeft - track.clientWidth;
    }

    /* scrollLeft som lägger det FÖRSTA riktiga kortet i vänsterkanten. 0 utan kloner. */
    function start() {
      var a = alla(), r = riktiga();
      if (!a.length || !r.length) return 0;
      return x(r[0]) - x(a[0]);
    }
    /* Bredden på EN uppsättning riktiga kort – mätt som avståndet till klonen av kort 1.
     * 0 betyder "ingen loop aktiv" och stänger av all wrap-logik nedan. */
    function setW() {
      var forsta = track.querySelector('[' + KLON + '="huvud"]');
      var r = riktiga();
      if (!forsta || !r.length) return 0;
      return Math.max(0, x(forsta) - x(r[0]));
    }

    function pageCount() { return Math.max(1, Math.ceil(riktiga().length / perView())); }
    /* Målposition för sida i, uttryckt i spårets koordinater (alltså inkl. start-offseten). */
    function targetFor(i) {
      var r = riktiga();
      if (!r.length) return 0;
      var idx = Math.min(i * perView(), r.length - 1);
      var rel = r[idx] ? x(r[idx]) - x(r[0]) : 0;
      var s = start();
      if (setW()) return s + rel;
      return Math.max(0, Math.min(rel, track.scrollWidth - track.clientWidth));
    }
    function current() {
      var r = riktiga();
      if (!r.length) return 0;
      var w = setW(), pv = perView(), n = Math.max(1, Math.ceil(r.length / pv));
      var rel = track.scrollLeft - start(), max = track.scrollWidth - track.clientWidth;
      if (w) rel = ((rel % w) + w) % w;   // varv-agnostiskt: sida 0 är sida 0 på varje varv
      var best = 0, bd = Infinity, x0 = x(r[0]);
      for (var i = 0; i < n; i++) {
        var mal = x(r[Math.min(i * pv, r.length - 1)]) - x0, d;
        if (w) {
          d = Math.abs(mal - rel);
          d = Math.min(d, w - d); // strax före nästa varvs första kort ÄR sida 0
        } else {
          d = Math.abs(Math.max(0, Math.min(mal, max)) - rel);
        }
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function sync() {
      if (!dotsWrap) return;
      var c = current();
      [].forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === c); });
    }

    /* Teleport utan animation. scroll-behavior nollas tillfälligt, annars glider spåret
     * synligt tillbaka i stället för att bara byta varv. */
    function hoppa(px) {
      var b = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = px;
      track.style.scrollBehavior = b;
    }

    /* ⚠️⚠️ KORTEN UTANFÖR BILD AVSLÖJAS DIREKT – INTE ETT OCH ETT NÄR DE SVEPS FRAM.
     * Scroll-reveal (wubs-motion) döljer `.wubs-prods__grid > *` tills IntersectionObservern sett
     * kortet. Ett kort utanför spårets synliga bredd är BORTKLIPPT, så observern såg det först när
     * kunden svept fram det – och då tonade det in (0,7 s + upp till 480 ms stagger) MEDAN kunden
     * svepte. Tomma rutor som fylldes i efteråt: det var den "buggiga" känslan.
     *
     * baraDolda = true  → bara kort som till minst 90 % ligger utanför spårets synliga bredd.
     *   Det är ofarligt när som helst – kunden kan inte se dem – så det körs vid bygget och på
     *   varje scroll-händelse. De synliga korten behåller sin intoning.
     *   ⚠️ Gränsen är 10 % och inte "någon pixel syns": wubs-motion avslöjar ett kort först när
     *   5 % av det syns, så en flisa i kanten hade annars stått tom tills någon svepte.
     * baraDolda = false → allt, också synliga kort. Bara när kunden själv rör karusellen
     *   (svep, pil, prick) eller när den byter varv. Aldrig från hoppa() – byggKloner() hoppar
     *   till startpositionen redan vid bygget, och då hade intoningen försvunnit överallt.
     *
     * `WubsMotion.visa()` duger inte här: den lägger bara klassen, och då körs övergången ändå.
     * Här stängs övergången av, klassen läggs på, EN synkron reflow sätter slutläget för alla
     * kort på en gång, och sedan slås övergången på igen.
     * (Recensionsspåret avslöjas i stället som HELHET – wubs-motion observerar själva spåret –
     * så där är det här ett ofarligt no-op.) */
    function avsloja(baraDolda) {
      var dolda = riktiga().filter(function (k) { return !k.classList.contains('is-inview'); });
      if (!dolda.length) return;
      if (baraDolda) {
        var tr = track.getBoundingClientRect();
        dolda = dolda.filter(function (k) {
          var b = k.getBoundingClientRect();
          var synligt = Math.min(b.right, tr.right) - Math.max(b.left, tr.left);
          return b.width > 0 && synligt < b.width * 0.1;
        });
        if (!dolda.length) return;
      }
      dolda.forEach(function (k) {
        k.style.transition = 'none';
        k.classList.add('is-inview');
      });
      void track.offsetWidth;
      dolda.forEach(function (k) { k.style.transition = ''; });
    }

    function korrigera() {
      var w = setW();
      if (!w) return;
      var s = start(), sl = track.scrollLeft;
      if (sl >= s - 1 && sl <= s + w - 1) return;
      /* Antal HELA uppsättningar utanför de riktiga korten – med flera varv kloner kan ett
       * långt svep hamna mer än ett varv bort, och då ska det bytas i ett enda hopp. */
      var varv = Math.floor((sl - s + 1) / w);
      avsloja(false);
      hoppa(sl - varv * w);
    }

    /* ⚠️ Sista utvägen: har kunden svept så hårt att klonerna tagit slut står spåret vid sin
     * absoluta kant och skulle stanna som en vanlig karusell. DÅ byter vi varv direkt, mitt i
     * rullningen. Det avbryter tröghetsrullningen – men alternativet är en tvärnit. Med minst en
     * hel uppsättning kloner på var sida (se byggKloner) nås kanten i praktiken aldrig. */
    function nodkorrigera() {
      var w = setW();
      if (!w) return;
      var sl = track.scrollLeft, max = track.scrollWidth - track.clientWidth;
      if (sl > 0 && sl < max - 0.5) return;
      /* ⚠️ Målet MÅSTE ligga på en kortkant. Spårets högerkant är ingen snap-punkt (sista
       * kortet ligger tryckt mot kanten), så ett rakt `sl - setW` hamnade mellan två kort
       * och scroll-snap flyttade oss en halv kortbredd EFTERÅT – uppmätt landade vi på fel
       * kort. Avrunda till rutnätet, så gör snap ingenting. */
      var s = start(), st = step();
      var mal = sl <= 0 ? sl + w : sl - w;
      avsloja(false);
      hoppa(s + Math.round((mal - s) / st) * st);
    }

    /* Pilar och prickar glider från ett läge PÅ de riktiga kortens varv. I vila står spåret redan
     * där (korrigera ser till det) – det här slår bara till om man klickar medan en tidigare
     * rullning pågår, och då kunde en hel vy framåt ha gått förbi klonerna. Klonerna visar samma
     * pixlar, så flytten syns inte. */
    function tillRiktigtVarv() {
      var w = setW();
      if (!w) return;
      var s = start(), sl = track.scrollLeft;
      var varv = Math.floor((sl - s + step() / 2) / w);
      if (varv) hoppa(sl - varv * w);
    }

    function klon(el, typ) {
      var c = el.cloneNode(true);
      c.setAttribute(KLON, typ);
      c.setAttribute('aria-hidden', 'true');
      /* ⚠️ Klonen avslöjas DIREKT. Scroll-reveal-lagret döljer `.wubs-prods__grid > *` tills
       * IntersectionObservern sett dem, och en klon som tonar in mitt i ett varvbyte skulle
       * spräcka illusionen av att karusellen är oändlig. Originalens intoning är kvar. */
      c.classList.add('is-inview');
      /* Klonerna är fullt klickbara – ATC, quick add och hjärtat körs av DELEGERADE
       * lyssnare på document och bryr sig inte om vilket kort klicket kom från. Men de
       * ska inte bli dubbla tab-stopp eller läsas upp två gånger. */
      c.querySelectorAll('a, button, input, select, textarea').forEach(function (f) {
        f.tabIndex = -1;
      });
      /* Temaeditorns blockmarkering (`block.shopify_attributes`, finns bara i editorn) följer INTE
       * med. Editorn letar upp blocket via sin första träff i DOM:en – och det hade varit
       * svansklonen till vänster om bild, så markeringen hade hamnat på fel kort. */
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('[data-shopify-editor-block]').forEach(function (e) {
        e.removeAttribute('data-shopify-editor-block');
      });
      return c;
    }

    function rensaKloner() {
      alla().forEach(function (e) { if (e.hasAttribute(KLON)) e.remove(); });
    }

    function byggKloner() {
      rensaKloner();
      if (!loopa || nav.hidden) return;
      var r = riktiga();
      if (r.length < 2) return;
      /* ⚠️ Minst en HEL uppsättning på var sida (förr en vy + ett kort, minst tre) – och fler
       * varv när uppsättningen är liten mot vyn. Två skäl:
       * 1. Ett hårt svep på en telefon rullar långt förbi tre kort. Tog klonerna slut fick
       *    nödkorrigeringen byta varv mitt i tröghetsrullningen – spåret tvärstannade.
       * 2. Pilen flyttar en hel vy. Står man på sista riktiga sidan måste det finnas en vy
       *    kloner till höger om den, alltså måste bufferten rymma två vyer. Artikelkarusellen
       *    (4 kort, 3 per vy) får därför två varv på var sida; startsidan och PDP:n ett.
       * Kostnad: (2 × varv + 1) × antalet kort i DOM:en. */
      var varv = Math.max(1, Math.ceil(2 * perView() / r.length));

      /* ⚠️ Bygg svansen i ett fragment. insertBefore(x, firstChild) i en loop lägger korten
       * i OMVÄND ordning, så de sista korten hade kommit baklänges före de riktiga. */
      var frag = document.createDocumentFragment();
      for (var v = 0; v < varv; v++) {
        for (var i = 0; i < r.length; i++) frag.appendChild(klon(r[i], 'svans'));
      }
      track.insertBefore(frag, track.firstChild);
      for (var u = 0; u < varv; u++) {
        for (var j = 0; j < r.length; j++) track.appendChild(klon(r[j], 'huvud'));
      }

      hoppa(start());
    }

    /* ⚠️ Klonerna byggs BARA om när layouten faktiskt ändrats (antal kort per vy eller
     * antal kort). Ett resize-event kommer varje gång mobilens adressfält glider undan,
     * och en ombyggnad nollställer scrollpositionen – karusellen hade hoppat tillbaka till
     * början mitt i att kunden bläddrade. Samma lärdom som artikelns innehållsförteckning. */
    var senastPerView = 0, senastAntal = -1;
    function buildDots() {
      /* Ett spår utan bredd (dold sektion, inte utlagt än) går inte att mäta – då blev det en
       * prick per kort. Vänta: ResizeObserver och load bygger när bredden finns. */
      if (track.clientWidth <= 0) { nav.hidden = true; return; }
      var overflow = riktigMaxScroll() > 4;
      var n = overflow ? pageCount() : 1;
      nav.hidden = n <= 1; // dölj pilar OCH prickar när allt får plats

      if (dotsWrap) {
        var need = nav.hidden ? 0 : n;
        if (dotsWrap.children.length !== need) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < need; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'wpb-dot';
            d.setAttribute('aria-label', 'Sida ' + (i + 1));
            (function (idx) {
              d.addEventListener('click', function () {
                avsloja(false);
                tillRiktigtVarv();
                track.scrollTo({ left: targetFor(idx), behavior: 'smooth' });
              });
            })(i);
            dotsWrap.appendChild(d);
          }
        }
      }

      var pv = perView(), antal = riktiga().length;
      if (pv !== senastPerView || antal !== senastAntal) {
        byggKloner();
        senastPerView = pv;
        senastAntal = antal;
      }

      /* ⚠️⚠️ Kort som injicerats av JS (PDP:ns hämtade rekommendationer) har ALDRIG passerat
       * scroll-reveal-observern och ligger då kvar på opacity 0 – sektionen ser tom ut fast
       * markupen finns. Anmäl spåret varje gång innehållet kan ha ändrats. */
      if (window.WubsMotion) {
        window.WubsMotion.scan(track);
        /* wubs-motion ger vid sin init varje barn i spåret en fördröjning efter sitt INDEX
         * (60 ms per kort, tak 8). Hinner klonerna byggas först hamnar svansklonerna före de
         * riktiga korten, och då landar alla riktiga kort på taket och tonar in samtidigt.
         * Räkna därför om från det första riktiga kortet – det står längst till vänster i vila.
         * buildDots körs igen vid load, alltså efter wubs-motion oavsett skriptordning. */
        riktiga().forEach(function (k, idx) {
          if (!k.classList.contains('is-inview')) k.style.transitionDelay = Math.min(idx, 8) * 60 + 'ms';
        });
      }
      avsloja(true);

      sync();
    }

    nav.querySelectorAll('.wpb-arrow-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        avsloja(false);
        var d = b.dataset.dir === 'next' ? 1 : -1;
        if (setW()) {
          /* Med loop finns det alltid kort åt båda håll – flytta en hel vy och låt
           * korrigeringen byta varv när scrollen stannat. Det är så "första kortet
           * kommer tillbaka" efter det sista.
           * ⚠️ Räkna från kortet som står i VILA, inte från scrollLeft mitt i en glidning:
           * klickade man igen innan förra glidningen landat hamnade målet mellan två kort. */
          tillRiktigtVarv();
          var st = step(), s = start();
          var bas = s + Math.round((track.scrollLeft - s) / st) * st;
          track.scrollTo({ left: bas + d * perView() * st, behavior: 'smooth' });
        } else {
          var next = Math.max(0, Math.min(current() + d, pageCount() - 1));
          track.scrollTo({ left: targetFor(next), behavior: 'smooth' });
        }
      });
    });

    /* ── SCROLL ─────────────────────────────────────────────────────────────────────────
     * ⚠️⚠️ FÖRR STOD HÄR `if (t) return; t = setTimeout(korrigera, 120)` – en STRYPNING, inte en
     * debounce. Timern startade vid FÖRSTA scroll-händelsen och varvbytet kördes sedan var 120:e
     * ms så länge man svepte, alltså mitt i dragningen. Svepte man vänster från start låg man
     * direkt bland klonerna, och spåret teleporterades medan fingret fortfarande drog: det
     * hoppade och tröghetsrullningen dog.
     * Nu väntar varvbytet på `scrollend`. Bakom den ligger en debounce – timern startas om vid
     * VARJE händelse, så den går först när spåret stått still – och aldrig medan ett finger
     * ligger på spåret. */
    var t = null, fingerNere = false, syncPlanerad = false;
    function scrollSlut() {
      clearTimeout(t);
      t = null;
      korrigera();
      sync();
    }
    /* Debouncen är enda vägen i webbläsare utan `scrollend` (äldre Safari) och en säkerhetslina i
     * övriga: uteblir `scrollend` av någon anledning byts varvet ändå. Hann den före är
     * korrigeringen här en no-op. Längre väntan när `scrollend` finns, så att den alltid hinner
     * först i normalfallet. */
    function planeraSlut() {
      clearTimeout(t);
      t = setTimeout(function () { if (!fingerNere) scrollSlut(); }, HAR_SCROLLEND ? 300 : 150);
    }
    track.addEventListener('scroll', function () {
      nodkorrigera();
      /* Rullar spåret medan ett finger ligger på det sveper kunden i karusellen – då ska allt
       * vara framme. Annars bara det som ligger bortklippt, så att en programmatisk rullning
       * aldrig tar intoningen från kort som syns. */
      avsloja(!fingerNere);
      /* Prickarna följer med under rullningen – en uppdatering per bildruta räcker. */
      if (!syncPlanerad) {
        syncPlanerad = true;
        requestAnimationFrame(function () { syncPlanerad = false; sync(); });
      }
      planeraSlut();
    }, { passive: true });
    if (HAR_SCROLLEND) track.addEventListener('scrollend', scrollSlut);

    /* Varvbytet väntar tills sista fingret släppt. */
    track.addEventListener('touchstart', function () { fingerNere = true; }, { passive: true });
    function slappt(e) {
      fingerNere = !!(e.touches && e.touches.length);
      planeraSlut();
    }
    track.addEventListener('touchend', slappt, { passive: true });
    track.addEventListener('touchcancel', slappt, { passive: true });
    /* Styrplatta i sidled = kunden bläddrar i karusellen. Lodrätt hjul är sidscroll och får
     * inte röra korten – då hade de synliga korten tappat sin intoning när musen råkade
     * passera över karusellen. */
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) avsloja(false);
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(buildDots, 150);
    });
    /* …och när spåret självt byter bredd utan att fönstret gör det (en sektion som visas först
     * efter laddning, temaeditorn). Bara BREDDEN räknas: ett "Läs mer" som fäller ut ett kort
     * ändrar spårets höjd, och det ska inte bygga om något. */
    if ('ResizeObserver' in window) {
      var senastBredd = track.clientWidth;
      new ResizeObserver(function () {
        if (track.clientWidth === senastBredd) return;
        senastBredd = track.clientWidth;
        clearTimeout(rt);
        rt = setTimeout(buildDots, 150);
      }).observe(track);
    }
    window.addEventListener('load', buildDots);

    buildDots();
    root.wubsCarousel = {
      buildDots: buildDots, pageCount: pageCount, perView: perView, current: current,
      setW: setW, start: start, step: step, korrigera: korrigera, nodkorrigera: nodkorrigera,
      riktiga: riktiga, alla: alla, avsloja: avsloja
    };
  }

  function initieraAlla() { document.querySelectorAll('[data-wth-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initieraAlla);
  else initieraAlla();
  // Temaeditorn renderar om sektioner – initiera nytillkomna spår.
  document.addEventListener('shopify:section:load', initieraAlla);
})();
